import template from '../templates/item_content.jst';

import "vendor/backbone/stickit";

import View from "backdraft-app/src/view";

export default class KeywordsItemContent extends View {
  get attributes() {
    return {
      "data-id": "keyword-item"
    };
  }

  get bindings() {
    return {
      "input": "name",
      "select": "speaker"
    };
  }

  initialize(options) {
    super.initialize(options);
    this.options = options;
  }

  render() {
    this.$el.html(template({ model: this.model, readOnly: this.options.readOnly }));
    this.stickit();
    return this;
  }
}
